module.exports = __webpack_public_path__ + "static/media/pic-laufrouten-2.f181b954.jpg";